import {
    ROUTER_DELIVERY_INSTRUCTION,
    ROUTER_ORDER_APPLY,
    ROUTER_ORDER_BRIDGE,
    ROUTER_ORDER_CHECK_OUT,
    // ROUTER_ORDER_CLAIM,
    ROUTER_ORDER_COUPON,
    ROUTER_ORDER_DELIVERY,
    ROUTER_ORDER_DELIVERY_TRACKING,
    ROUTER_ORDER_DETAIL,
    ROUTER_ORDER_FAIL,
    ROUTER_ORDER_FAMILY_PAY,
    ROUTER_ORDER_FDS_AUTH_BRIDGE,
    ROUTER_ORDER_PAYMENT_METHODS,
    ROUTER_ORDER_POP_UP,
    ROUTER_ORDER_PURCHASE_CONFIRMATION,
    ROUTER_ORDER_RESULT,
    ROUTER_ORDER_SALE_HISTORY,
    ROUTER_ORDER_SALE_SETTLEMENT,
    ROUTER_ORDER_SHEET,
    ROUTER_ORDER_SHEET_FAMILY_PAY,
    ROUTER_ORDER_SHEET_SELLER,
    ROUTER_ORDER_SHEET_SUBSCRIPTION,
} from '@web/core/routes'
// import {collectClaimStore} from '@web/pages/claim/collect'
// import {detailClaimStore} from '@web/pages/claim/detail'
// import {paymentClaimStore} from '@web/pages/claim/payment'
// import {requestClaimStore} from '@web/pages/claim/request'
// import {resultClaimStore} from '@web/pages/claim/result'
import {DeliveryStore} from '@web/pages/delivery'
import {DeliveryInstructionStore} from '@web/pages/deliveryInstruction'
import {DeliveryTrackingStore} from '@web/pages/deliveryTracking'
import {familyPayCheckoutStore, familyPayMemberStore} from '@web/pages/familyPay'
import {fleaMarketCheckoutStore} from '@web/pages/fleaMarket'
import {CouponManagementStore} from '@web/pages/management/coupon'
import {paymentMethodManagementStore} from '@web/pages/management/paymentMethod'
import {orderCheckoutStore, orderTemporaryStore} from '@web/pages/order'
import {orderDetailStore} from '@web/pages/orderDetail'
import {orderResultStore} from '@web/pages/orderResult'
import {purchaseConfirmationResultStore, purchaseConfirmationStore} from '@web/pages/purchaseConfirmation'
import {saleHistoryStore} from '@web/pages/saleHistory'
import {saleSettlementStore} from '@web/pages/saleSettlement'
import {
    applyStore as subscriptionApplyStore,
    failStore as subscriptionFailStore,
    fdsBridgeStore as subscriptionFdsBridgeStore,
    subscriptionResultStore,
    subscriptionStore,
} from '@web/pages/shoppingSubscription'
import {smartStoreCheckoutStore, smartStoreResultStore} from '@web/pages/smartstore'

const orderCheckoutStorePrefixes = [
    ROUTER_ORDER_CHECK_OUT.MAIN,
    ROUTER_ORDER_BRIDGE,
    ROUTER_ORDER_APPLY.MAIN,
    ROUTER_ORDER_FAIL.MAIN,
    ROUTER_ORDER_POP_UP.MAIN,
]
const orderTemporaryStorePrefixes = [ROUTER_ORDER_FDS_AUTH_BRIDGE, ROUTER_ORDER_POP_UP.BRIDGE]
const orderDeliveryStorePrefixes = [
    ROUTER_ORDER_DELIVERY.DELIVERY,
    ROUTER_ORDER_DELIVERY.ZIPCODE,
    ROUTER_ORDER_DELIVERY.DELIVERY_ORDER_RESULT,
    ROUTER_ORDER_DELIVERY.DELIVERY_SCHEDULED_ORDER_RESULT,
]

const useStore = () => {
    const pathname = window.location.pathname

    const isPathPrefixMatch = (path: string) => pathname.startsWith(path)

    // 추후 제거
    if (isPathPrefixMatch(ROUTER_ORDER_SHEET_SELLER.RESULT)) {
        return smartStoreResultStore
    } else if (isPathPrefixMatch(ROUTER_ORDER_SHEET_SELLER.MAIN)) {
        return smartStoreCheckoutStore
    } else if (ROUTER_ORDER_RESULT.MAIN.isPathPrefixMatch()) {
        return orderResultStore
    } else if (
        orderCheckoutStorePrefixes.some((prefix) => isPathPrefixMatch(prefix)) ||
        ROUTER_ORDER_SHEET.MALL.CHECK_OUT.isPathPrefixMatch() ||
        ROUTER_ORDER_SHEET.EASY_BOOKING.CHECK_OUT.isPathPrefixMatch() ||
        ROUTER_ORDER_SHEET.LOCAL_PAY.CHECK_OUT.isPathPrefixMatch() ||
        ROUTER_ORDER_SHEET.BLOG.CHECK_OUT.isPathPrefixMatch()
    ) {
        return orderCheckoutStore
    } else if (ROUTER_ORDER_SHEET.FLEA_MARKET.CHECK_OUT.isPathPrefixMatch()) {
        return fleaMarketCheckoutStore
    } else if (orderTemporaryStorePrefixes.some((prefix) => isPathPrefixMatch(prefix))) {
        return orderTemporaryStore
    } else if (ROUTER_ORDER_DETAIL.MAIN.isPathPrefixMatch()) {
        return orderDetailStore
    } else if (ROUTER_ORDER_PURCHASE_CONFIRMATION.RESULT.isPathPrefixMatch()) {
        return purchaseConfirmationResultStore
    } else if (ROUTER_ORDER_PURCHASE_CONFIRMATION.MAIN.isPathPrefixMatch()) {
        return purchaseConfirmationStore
    } else if (ROUTER_ORDER_SALE_HISTORY.MAIN.isPathPrefixMatch()) {
        return saleHistoryStore
    } else if (ROUTER_ORDER_SALE_SETTLEMENT.MAIN.isPathPrefixMatch()) {
        return saleSettlementStore
    } else if (ROUTER_ORDER_FAMILY_PAY.MAIN.isPathPrefixMatch()) {
        return familyPayMemberStore
    } else if (isPathPrefixMatch(ROUTER_ORDER_SHEET_FAMILY_PAY.ROOT)) {
        return familyPayCheckoutStore
    } else if (ROUTER_ORDER_DELIVERY_TRACKING.ROOT.isPathPrefixMatch()) {
        return DeliveryTrackingStore
        /**
         * orderDeliveryStorePrefixes 내부에 /order/delivery가 있어서
         * /order/deliveryInstruction 경로가 매칭되는 문제가 있으므로
         * DeliveryInstruction 인지 검증을 필히 먼저 수행해야한다.
         */
    } else if (ROUTER_DELIVERY_INSTRUCTION.MAIN.isPathPrefixMatch()) {
        return DeliveryInstructionStore
    } else if (orderDeliveryStorePrefixes.some((prefix) => isPathPrefixMatch(prefix))) {
        return DeliveryStore
    } else if (ROUTER_ORDER_COUPON.ROOT.isPathPrefixMatch()) {
        return CouponManagementStore
    } else if (ROUTER_ORDER_PAYMENT_METHODS.ROOT.isPathPrefixMatch()) {
        return paymentMethodManagementStore
    } else if (ROUTER_ORDER_SHEET_SUBSCRIPTION.ROOT.isPathPrefixMatch()) {
        if (pathname.includes('apply')) {
            return subscriptionApplyStore
        } else if (pathname.includes('fail')) {
            return subscriptionFailStore
        } else if (pathname.includes('result')) {
            return subscriptionResultStore
        } else if (pathname.includes('fds')) {
            return subscriptionFdsBridgeStore
        }

        return subscriptionStore
    }
    // else if (ROUTER_ORDER_CLAIM.ROOT.isPathPrefixMatch()) {
    //     if (ROUTER_ORDER_CLAIM.REQUEST.ROOT.isPathPrefixMatch()) {
    //         return requestClaimStore
    //     } else if (ROUTER_ORDER_CLAIM.COLLECT.ROOT.isPathPrefixMatch()) {
    //         return collectClaimStore
    //     } else if (ROUTER_ORDER_CLAIM.PAYMENT.ROOT.isPathPrefixMatch()) {
    //         return paymentClaimStore
    //     } else if (ROUTER_ORDER_CLAIM.RESULT.ROOT.isPathPrefixMatch()) {
    //         return resultClaimStore
    //     } else if (ROUTER_ORDER_CLAIM.DETAIL.ROOT.isPathPrefixMatch()) {
    //         return detailClaimStore
    //     }
    // }

    return orderCheckoutStore
}

export default useStore
